import gql from "graphql-tag";

export const HEALTH_CHECK_QUERY = gql`
    query HealthCheck {
        search {
            healthCheck
        }
    }
`;
